<template>
  <div id="extra-component-form-validation-demo">
    <FleetGroupList></FleetGroupList>
  </div>
</template>

<script>

import FleetGroupList from "./AlertList.vue"

export default {
  components: {
    FleetGroupList
  }
}
</script>
